import { SET_VARIANT } from './names';

export const setVariant = variant => ({
  type: SET_VARIANT,
  variant,
});
